import * as Scrivito from "scrivito";

Scrivito.provideComponent("LocalizedKeyWidget", ({ widget }) => (
  <div className="row border-top border-bottom">
    <Scrivito.ContentTag
      tag="div"
      className="col-sm border-left pt-2"
      content={widget}
      attribute="key"
    />
    <Scrivito.ContentTag
      tag="div"
      className="col-sm border-left pt-2"
      content={widget}
      attribute="de"
    />
    <Scrivito.ContentTag
      tag="div"
      className="col-sm border-left border-right pt-2 pb-2"
      content={widget}
      attribute="en"
    />
  </div>
));
